
import React from "react";
import i18n from "../../../i18n";

const LabelDP=(props)=>{
    switch(props.value){
        case 1:
            return <div className="badge badge-light-success">{i18n.t("Active")}</div>
        case 0:
            return <div className="badge badge-light-danger">{i18n.t("Void")}</div>
        case 2:
            return <div className="badge badge-light-info">{i18n.t("Close")}</div>
    }
}
export default LabelDP;